import type { MouseEvent } from "react";
import { footerNote, navLinks } from "@/mocks/homeContent";

const quickLinks = [
  { icon: "ri-fire-fill", label: "今日热度榜" },
  { icon: "ri-stack-fill", label: "圈层专题合集" },
  { icon: "ri-chat-smile-3-line", label: "短讯速览" },
  { icon: "ri-history-fill", label: "更新动态" },
];

export default function Footer() {
  const go = (href: string) => (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer id="about" className="border-t border-secondary-200/70 bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* 关于本站 */}
          <div>
            <a href="#top" onClick={go("#top")} className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-base leading-none"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">吃瓜网址</span>
            </a>
            <h2 className="mt-5 text-sm font-bold text-foreground-900">关于本站</h2>
            <p className="mt-2 text-sm leading-6 text-foreground-600">
              一个按圈层归拢的吃瓜内容聚合入口。换地址期间认准本页「吃瓜网址新地址」，今日热榜、专题合集与短讯速览集中放送，追瓜不掉线。
            </p>
            <p className="mt-4 rounded-lg border border-secondary-200 bg-background-50 px-3.5 py-3 text-xs leading-5 text-foreground-500">
              {footerNote}
            </p>
          </div>

          {/* 板块直达 */}
          <div>
            <h3 className="text-sm font-bold text-foreground-900">板块直达</h3>
            <ul className="mt-3 space-y-1">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={go(l.href)}
                    className="inline-flex items-center gap-2 rounded-md px-1 py-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-arrow-right-s-line text-base leading-none"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 快速追瓜 */}
          <div>
            <h3 className="text-sm font-bold text-foreground-900">快速追瓜</h3>
            <ul className="mt-3 grid grid-cols-1 gap-1 sm:grid-cols-2 md:grid-cols-1">
              {quickLinks.map((q) => (
                <li key={q.label}>
                  <a
                    href="#top"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className="inline-flex items-center gap-2 rounded-md px-1 py-1.5 text-sm text-foreground-600 transition-colors hover:text-accent-800"
                  >
                    <i className={`${q.icon} text-base leading-none text-accent-600`}></i>
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-secondary-200/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜网址 · 最新发布聚合入口
          </p>
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-shield-check-line text-sm leading-none text-secondary-600"></i>
              静态演示页面
            </span>
            <span className="hidden sm:inline">·</span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-links-fill text-sm leading-none text-secondary-600"></i>
              认准「吃瓜网址新地址」
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}